import { Button } from "@mantine/core";
import { modals } from "@mantine/modals";
import { notifications } from "@mantine/notifications";
import type { JSX } from "react";
import { useMutation } from "urql";
import { editMutation, type TuneThreadEditMutation, type TuneThreadEditMutationVariables } from "./queries";
import ReferenceForm, { type IFormValues } from "./ReferenceForm";

interface IProps {
    tuneThread: {
        id: number;
        referenceAnswer: string | null;
        llmJudge: string | null;
    };
    disabled: boolean;
}

function EditReferenceButton({ tuneThread, disabled }: IProps): JSX.Element {
    const [updateResult, executeUpdate] = useMutation<TuneThreadEditMutation, TuneThreadEditMutationVariables>(
        editMutation,
    );

    const edit = async (values: IFormValues) => {
        const result = await executeUpdate({
            data: {
                tuneThreadId: tuneThread.id,
                referenceAnswer: values.referenceAnswer || null,
                llmJudge: values.llmJudge || null,
            },
        });
        if (result.error) {
            notifications.show({
                title: "Failed to update reference result",
                message: result.error.message,
            });
        } else {
            notifications.show({
                title: "Thread updated",
                message: "Reference result for thread updated",
            });
        }
    };

    const initialValues: IFormValues = {
        referenceAnswer: tuneThread.referenceAnswer || "",
        llmJudge: tuneThread.llmJudge || "",
    };

    const onClick = () =>
        modals.open({
            title: "Edit reference result",
            size: "800px",
            children: (
                <ReferenceForm
                    fetching={updateResult.fetching}
                    handleSubmit={(values) => {
                        edit(values);
                        modals.closeAll();
                    }}
                    initialValues={initialValues}
                />
            ),
        });

    const buttonText = !tuneThread.llmJudge ? "Edit reference*" : "Edit reference";

    return (
        <Button onClick={onClick} disabled={updateResult.fetching || disabled}>
            {buttonText}
        </Button>
    );
}

export default EditReferenceButton;
